// extracted by mini-css-extract-plugin
export default {"titleRow":"EaMF5BNFlAOb1vzFd5Ie","title":"LYPY1wTotrleT5ORgNz0","description":"CWepHUnZqKoUcXEYQ0yh"};